const XQuery = (searchQuery, commandList) => {
    let queryParts = [encodeURIComponent(searchQuery)];

  
    // X用のコマンド処理
    commandList.forEach(({ command, value }) => {
        if (value) {

            if (value.startsWith("filter:")) {
                queryParts.push(`${encodeURIComponent(value)}`);
            } else {

                switch (command) {
                    case 'keyword':
                        queryParts.push(`${encodeURIComponent(value)}`);
                        break;
                    case '""':
                        queryParts.push(`"${encodeURIComponent(value)}"`);
                        break;
                    case '-':
                        queryParts.push(`-${encodeURIComponent(value)}`);
                        break;
                    default:
                        queryParts.push(`${command}${encodeURIComponent(value)}`);
                    }


            }



            }
          });

    // 複数の検索項目がある場合に限り、'+'で連結
    const fullQuery = queryParts.length > 1 ? queryParts.join('+') : queryParts[0];
    return 'https://twitter.com/search?q=' + fullQuery;
};

export default XQuery;


